<template>
  <v-card
    :style="{
      background: value.sectionColor.backGround,
      color: value.sectionColor.text,
    }"
    class="pa-4 rounded-0"
    flat
  >
    <v-card-title class="section-title pa-2" style="color: inherit !important">
      {{ value.title }}
    </v-card-title>
    <v-card-subtitle class="ma-0 pa-2" style="color: inherit !important">
      {{ value.description }}
    </v-card-subtitle>

    <v-row v-if="value && value.items.length > 0" no-gutters>
      <v-col cols="12">
        <v-stepper v-if="showFeedback" v-model="e1" class="transparent" flat>
          <v-card
            class="rounded-lg px-2"
            color="rgba(255, 255, 255, .25)"
            outlined
          >
            <v-stepper-header
              class="flex-nowrap overflow-x-auto custom-scrollbar elevation-0"
            >
              <template v-for="i in value.items.length">
                <v-stepper-step
                  :id="`step-${i}`"
                  :key="`${i}-step`"
                  :complete="e1 > i"
                  :step="i"
                  class="py-2 px-8"
                >
                  <span class="text-no-wrap">{{ $t("question") }} {{ i }}</span>
                </v-stepper-step>

                <v-divider v-if="i !== value.items.length" :key="i" />
              </template>
            </v-stepper-header>
          </v-card>

          <v-stepper-items>
            <v-stepper-content
              v-for="n in value.items.length"
              :key="`${n}-content`"
              :step="n"
              class="pt-0 px-0"
            >
              <v-divider />

              <v-card class="mb-12 pa-2 transparent" flat>
                <pre v-html="value.items[n - 1].question" />
                <feedback-type
                  v-model="valueComputed.items[n - 1].value"
                  :type="valueComputed.items[n - 1].type"
                />

                <v-textarea
                  v-if="value.items[n - 1].description"
                  v-model="valueComputed.items[n - 1].answer"
                  :label="
                    value.items[n - 1].forceDesc
                      ? $t('description_required_label')
                      : $t('description_optional_label')
                  "
                  class="mt-4"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  :messages="$t('description_hint')"
                  outlined
                  rows="3"
                />
              </v-card>

              <v-btn
                :disabled="n - 1 === 0"
                class="me-2"
                outlined
                @click="e1 = n - 1"
              >
                {{ $t("back") }}</v-btn
              >

              <v-btn
                :disabled="
                  (!value.items[n - 1].value &&
                    value.items[n - 1].value !== 0) ||
                  (value.items[n - 1].description &&
                    value.items[n - 1].forceDesc &&
                    (!value.items[n - 1].answer ||
                      value.items[n - 1].answer.length < 3))
                "
                color="primary"
                @click="nextStep(n)"
              >
                {{ n < value.items.length ? $t("continue") : $t("register") }}
              </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import FeedbackType from "../cm/feedbackType";

export default {
  name: "bFeedbackView",

  components: { FeedbackType },

  props: {
    value: [Object, Array],
  },

  data: () => ({
    e1: 1,
    showFeedback: true,
  }),

  computed: {
    
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    nextStep(n) {
      // let stepEl = document.getElementById(`step-${n}`);
      // stepEl.scrollIntoView({behavior: "smooth", inline: "center"})

      if (n === this.value.items.length) {
        this.storeFeedback();
        this.e1 = 1;
      } else {
        this.e1 = n + 1;
      }
    },
    storeFeedback() {
      this.showFeedback = false;
      this.$toast.success(this.$t("feedback_submitted_success"));
    },
  },
};
</script>

<style scoped>
.section-title {
  position: relative;
}

.section-title:before {
  content: "";
  width: 150px;
  height: 1px;
  background: var(--v-primary-base);
  position: absolute;
  bottom: 0;
  right: 0;
}

pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}
</style>
